import React from 'react';

function courseToDirection(course) {
  if (course === null || course === undefined) return null;
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return dirs[Math.round(course / 45) % 8];
}

export default function TrackerCard({ tracker, selected, onToggle, activeTrip }) {
  const isManual = tracker.manual;

  const lastSeen = tracker.last_seen
    ? new Date(tracker.last_seen).toLocaleString([], {
        month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
      })
    : null;

  const direction = courseToDirection(tracker.course);
  const speedLabel = tracker.speed > 0
    ? `${direction ? direction + ' at ' : ''}${tracker.speed} mph`
    : 'Stopped';

  const statusLabel = isManual ? 'No tracker'
    : tracker.state_label || (tracker.status === 'moving' ? 'Moving' : 'Parked');

  // Calculate trip miles so far:
  // 1. Prefer odometer subtraction (start_miles vs current)
  // 2. Fall back to accumulated Haversine miles if start_miles is null
  // 3. Show "Miles tracking..." if neither is available
  const tripMilesSoFar = activeTrip
    ? activeTrip.start_miles && tracker.total_miles
      ? Math.max(0, tracker.total_miles - activeTrip.start_miles)
      : activeTrip.trip_miles_accumulated > 0
      ? activeTrip.trip_miles_accumulated
      : null
    : null;

  return (
    <div
      className={`tracker-card ${selected ? 'selected' : ''} ${tracker.status || ''}`}
      onClick={() => onToggle(tracker.id)}
      style={{ cursor: 'pointer' }}
    >
      <div className="tracker-card-header" style={{ justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
          <span className={`status-dot ${isManual ? 'manual' : tracker.status}`} />
          <span className="tracker-name">{tracker.name}</span>
        </div>
        {/* Checkbox */}
        <div
          onClick={e => { e.stopPropagation(); onToggle(tracker.id); }}
          style={{
            width: '16px', height: '16px', borderRadius: '4px', flexShrink: 0,
            border: `2px solid ${selected ? '#f97316' : '#cbd5e1'}`,
            background: selected ? '#f97316' : 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', transition: 'all 0.15s',
          }}>
          {selected && (
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M2 5L4 7L8 3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
      </div>

      <div style={{ fontSize: '11px', color: isManual ? '#94a3b8' : tracker.status === 'moving' ? '#16a34a' : '#64748b', marginBottom: '8px', fontWeight: '500' }}>
        {statusLabel}
      </div>

      {/* Active trip banner */}
      {activeTrip && (
        <div style={{
          background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '6px',
          padding: '6px 8px', marginBottom: '8px', fontSize: '11px',
        }}>
          <div style={{ color: '#9a3412', fontWeight: '600', marginBottom: '2px' }}>
            On Trip — {activeTrip.contact_name || 'Unknown renter'}
          </div>
          <div style={{ color: '#c2410c' }}>
            {tripMilesSoFar != null ? `${tripMilesSoFar.toFixed(1)} mi so far` : 'Miles tracking...'}
          </div>
        </div>
      )}

      {!isManual && (
        <div className="tracker-card-stats" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div className="tracker-stat">
            <span className="stat-label">Miles</span>
            <span className="stat-value">
              {tracker.total_miles ? Math.round(tracker.total_miles).toLocaleString() + ' mi' : '—'}
            </span>
          </div>
          <div className="tracker-stat">
            <span className="stat-label">Speed</span>
            <span className="stat-value">{speedLabel}</span>
          </div>
          {tracker.battery !== null && tracker.battery !== undefined && (
            <div className="tracker-stat">
              <span className="stat-label">Battery</span>
              <span className="stat-value">{tracker.battery}%</span>
            </div>
          )}
          {tracker.network && (
            <div className="tracker-stat">
              <span className="stat-label">Network</span>
              <span className="stat-value">{tracker.network}</span>
            </div>
          )}
          {lastSeen && (
            <div className="tracker-stat" style={{ gridColumn: '1 / -1' }}>
              <span className="stat-label">Last update</span>
              <span className="stat-value">{lastSeen}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
